import { render, staticRenderFns } from "./ColoredUsername.vue?vue&type=template&id=b1d5c432&"
import script from "./ColoredUsername.vue?vue&type=script&lang=js&"
export * from "./ColoredUsername.vue?vue&type=script&lang=js&"
import style0 from "./ColoredUsername.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports